import styled from 'styled-components';
import CalendarIcon from 'components/Icons/calendar.svg';
import { formatYearAndMonth } from 'utils/dates';

const Wrapper = styled.div`
  background: #f6f6f6;
  display: flex;
  border-radius: 30px;
  gap: 4px;
  height: 32px;
  align-items: center;
  margin-right: -8px;
  min-width: 84px;
  padding: 8px;
`;

const Text = styled.div`
  color: #000;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
`;

export const PlateExpirationDate = ({ date }: { date: string }) => {
  return (
    <Wrapper>
      <CalendarIcon />
      <Text>{formatYearAndMonth(date)}</Text>
    </Wrapper>
  );
};
